import $ from 'jquery'
import ImagerieCliches from '@/components/imagerie-cliches/index.vue'
import ImagerieRapport from '@/components/imagerie-rapport/index.vue'
export default {
    name: 'manage-interpretation', components: { ImagerieCliches, ImagerieRapport },
    props: { selected_examen: Object, user_info: Object, toggler: Number },
    data() { return { visible: false, galleryRevision: 0 } },
    computed: { reportContext() { return { ...this.selected_examen, ville: this.ville, nom_clinique: this.nom_clinique } } },
    watch: { toggler() { this.visible = true } },
    mounted() {
        $(this.$refs.interpret_exam).on('hide.bs.modal.imgReport', event => { if (this.$refs.report && !this.$refs.report.canLeave()) event.preventDefault() })
        $(this.$refs.interpret_exam).on('hidden.bs.modal.imgReport', () => { this.visible = false })
    },
    beforeDestroy() { $(this.$refs.interpret_exam).off('.imgReport') },
    methods: { changed() { this.galleryRevision++; this.$emit('emitRefreshAttenteList') } }
}
